import { SortableWidgetProps } from '@creditsights/styleguide-web';

export const riskProductsDropdownOptions = [
  {
    text: 'All',
    value: 'all',
    key: 'all',
  },
  {
    text: '3 Months',
    value: '3m',
    key: '3m',
  },
  {
    text: '6 Months',
    value: '6m',
    key: '6m',
  },
  {
    text: '1 Year',
    value: '1y',
    key: '1y',
  },
  {
    text: '3 Years',
    value: '3y',
    key: '3y',
  },
  {
    text: '5 Years',
    value: '5y',
    key: '5y',
  },
] as const;

export type TimeFrameOptions = Pick<typeof riskProductsDropdownOptions[number], 'key'>['key'];
export interface RiskProductsProps extends SortableWidgetProps {
  companyTag: string;
  noPrint?: boolean;
  dynamicHeader?: boolean;
  rpMessage?: boolean;
  isTeaser?: boolean;
  defaultTimeframe?: TimeFrameOptions;
}
